<template>
  <div class="container mt-5">
    <h2 class="text-center mb-4">Havi nem visszaigazolt fogyás</h2>

    <!-- Show loading message or spinner while waiting for the data -->
    <div v-if="loading" class="text-center">
      <p>Adatok betöltése...</p> <!-- You can also add a spinner here if preferred -->
    </div>

    <!-- Table to display the data, only shows after data is loaded -->
    <table v-else class="table table-bordered table-striped">
      <thead class="thead-dark">
        <tr>
          <th>Hónap</th>
          <th>Összesítve</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loop through the data to create table rows -->
        <tr v-for="entry in attendanceData" :key="entry.count_id">
          <td>{{ getMonthName(entry.count_id) }}</td>
          <td>{{ entry.total_attended_count }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// Import axios
import axios from 'axios';

export default {
  name: 'AttendanceTable',
  data() {
    return {
      attendanceData: [], // Data to be populated from the backend
      loading: true, // Loading state to control when to show the table or the loading message
      currentYear: new Date().getFullYear() // Dynamically get the current year
    };
  },
  methods: {
    // Method to get month name by count_id (1-12) in Hungarian
    getMonthName(monthNumber) {
      const months = [
        "Január", "Február", "Március", "Április", "Május", "Június",
        "Július", "Augusztus", "Szeptember", "Október", "November", "December"
      ];
      return months[monthNumber - 1];
    },
    // Method to fetch data from the backend
    fetchAttendanceData() {
      // POST request to fetch data (replace URL with your actual backend endpoint)
      axios.post(this.$BACKEND_HOST + '/api/getstatistics/noshowmonth', { year: this.currentYear, grp_id: -1 })
        .then(response => {
          // Assuming the backend returns the data in the expected format
          this.attendanceData = response.data.value;
          console.log(this.attendanceData);
        })
        .catch(error => {
          console.error('There was an error fetching the attendance data:', error);
        })
        .finally(() => {
          // Set loading to false once data is fetched or an error occurs
          this.loading = false;
        });
    }
  },
  mounted() {
    // Fetch the data when the component is mounted
    this.fetchAttendanceData();
  }
};
</script>

<style scoped>
/* You can add custom styles here if needed */
</style>
